import axios from 'axios';
import { Api } from './api';

// Ambiente do Squidex. Os fallbacks são os valores de produção que estavam
// fixos aqui, para nenhum build existente parar de funcionar caso as variáveis
// não estejam definidas. Quando o pipeline passar a definir REACT_APP_SQUIDEX_*,
// os fallbacks podem sair.
//
// Em desenvolvimento o .env.development aponta para o app copasul-dev, e
// ASSETS_APP continua em produção: as imagens são servidas por URL pública, o
// que evita duplicar assets (e storage) no app de dev.
const SQUIDEX_HOST = (process.env.REACT_APP_API || 'https://cloud.squidex.io/').replace(/\/+$/, '');
export const SQUIDEX_APP = process.env.REACT_APP_SQUIDEX_APP || 'copasul';
const SQUIDEX_ASSETS_APP = process.env.REACT_APP_SQUIDEX_ASSETS_APP || SQUIDEX_APP;
const SQUIDEX_CLIENT = process.env.REACT_APP_SQUIDEX_CLIENT || 'copasul:website';
const SQUIDEX_SECRET =
  process.env.REACT_APP_SQUIDEX_SECRET || 'rwx90m9xvtpeusyq9ynji7yuych15mu8xutfopxizvcx';

export const baseUrlImg = `${SQUIDEX_HOST}/api/assets/${SQUIDEX_ASSETS_APP}/`;

// Squidex redimensiona a imagem sob demanda via querystring (ImageSharp),
// então pedimos só o tamanho que vamos exibir em vez do arquivo original.
// Só usamos width/height/quality (os parâmetros mais universais) -- "mode"
// varia entre versões do Squidex e, se o valor não for aceito, o pedido
// falha e a imagem some por completo em vez de só perder qualidade.
export const getAssetUrl = (assetId, { width, height, quality = 82, mode, format } = {}) => {
  if (!assetId) return '';
  const params = new URLSearchParams();
  if (width) params.set('width', width);
  if (height) params.set('height', height);
  if (quality) params.set('quality', quality);
  if (mode) params.set('mode', mode);
  if (format) params.set('format', format);
  const query = params.toString();
  return `${baseUrlImg}${assetId}${query ? `?${query}` : ''}`;
};

// URL original, sem nenhum parâmetro de redimensionamento -- usada como
// fallback caso a versão redimensionada falhe (ex.: parâmetro não suportado).
export const getRawAssetUrl = (assetId) => (assetId ? `${baseUrlImg}${assetId}` : '');

export const handleGetToken = async () => {
  const response = await Api.post(
    'identity-server/connect/token',
    {
      grant_type: 'client_credentials',
      client_id: SQUIDEX_CLIENT,
      client_secret: SQUIDEX_SECRET,
      scope: 'squidex-api',
    },
    {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    },
  ).catch((error) => console.log('error', error));
  return response;
};

// As ~47 chamadas espalhadas pelas páginas usam o caminho literal
// "api/content/copasul/...". Em vez de reescrever todas, o app é trocado aqui,
// no único ponto por onde todas passam. Ao migrar as chamadas para um helper de
// URL, esta normalização pode sair.
const comApp = (link = '') =>
  link.replace(/(^|\/)api\/content\/copasul\//, `$1api/content/${SQUIDEX_APP}/`);

// `extras`: cabeçalhos a mais, ex. { 'X-Fields': 'titulo,data' } para trazer só
// alguns campos (a lista de notícias não precisa do texto inteiro).
export const handleGetData = async (token, link, extras = {}) => {
  const response = await Api.get(comApp(link), {
    headers: {
      'X-Resolve-Urls': '*',
      Authorization: `Bearer ${token.toString()}`,
      ...extras,
    },
  });
  return response;
};

export const getVidesChannel = async (results, videoTitle) => {
  const baseURL = `https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=UCRNeyileM2kEiDwcS1jzFlQ&maxResults=${results}&order=date&type=video&q=${videoTitle}&key=AIzaSyCkC1q2O-9_CoqzOZcDn4QeQlgcb0GqEAY`;

  const response = await axios.get(baseURL);
  return response.data;
};

export const handlePostContact = async (link, payload, token) => {
  const response = await Api.post(comApp(link), payload, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token.toString()}`,
    },
  });
  return response;
};
